import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import Container from '../Container';
import RPGO from '../../../../../common/icons/rpgo.svg';
import { useExchangeTitleStyles } from './styles';
import PointsTitleTerm from './NoSubscribedPoints/PointsTitleTerm';

const ExchangeTitle = (props) => {
  const { Points: points, subscribed } = props.points;

  const classes = useExchangeTitleStyles();
  return (
    <Container>
      <Box display="flex" alignItems="center" flexDirection="column">
        {subscribed ? (
          <React.Fragment>
            <Typography className={classes.title}>
              Hasta la fecha has acumulado:
            </Typography>
            <Box display="flex" alignItems="center" justifyContent="center">
              <Typography className={classes.points}>
                {new Intl.NumberFormat('es-CL').format(points)}
              </Typography>
              <img src={RPGO} className={classes.image} />
            </Box>
          </React.Fragment>
        ) : (
          <PointsTitleTerm />
        )}
      </Box>
    </Container>
  );
};

ExchangeTitle.propTypes = {
  points: PropTypes.bool,
};

export default ExchangeTitle;
